import React, { useEffect, useRef } from "react";
import styles from "./VideoDialog.module.css";
import ImageComponent from "../../../components/ImageComponent";
import AssetsPack from "../../../util/AssetsPack";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";

interface VideoDialogProps {
  videoUrl: string;
  isOpen: boolean;
  title: string;
  onClose: () => void;
}

const VideoDialog: React.FC<VideoDialogProps> = ({
  isOpen,
  onClose,
  title,
  videoUrl,
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (isOpen && dialog && !dialog.open) {
      dialog.showModal();
    } else if (!isOpen && dialog?.open) {
      dialog.close();
    }
  }, [isOpen]);

  return (
    <dialog ref={dialogRef} className={styles.dialogRoot} onCancel={onClose}>
      <div className={styles.dialogContent}>
        <div className={styles["info-container"]}>
          <Paragraph
            size={ParagraphSize.paragraph2}
            classNameStyle={styles["title-text"]}
          >
            {title}
          </Paragraph>

          <ImageComponent
            src={AssetsPack.icons.ICON_CROSS.default}
            className={styles["exit-button"]}
            onClick={onClose}
          />
        </div>

        {/* <button className={styles["exit-button"]} onClick={onClose}>
          ✕
        </button> */}
        <div className={styles["phone-mockup"]}>
          <video
            className={styles["video-view"]}
            src={videoUrl}
            controls
            autoPlay
            controlsList="nodownload nofullscreen noremoteplayback"
          />
        </div>
        <div className={styles["fade-bottom"]} />
      </div>
    </dialog>
  );
};

export default VideoDialog;
